const addTogglePrevNextBtnsActiveRecommendations = (
  emblaApi,
  prevBtn,
  nextBtn,
) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
    else prevBtn.setAttribute('disabled', 'disabled');

    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
    else nextBtn.setAttribute('disabled', 'disabled');
  };

  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState);

  return () => {
    prevBtn.removeAttribute('disabled');
    nextBtn.removeAttribute('disabled');
  };
};

const addPrevNextBtnsClickHandlersRecommendations = (
  emblaApi,
  prevBtn,
  nextBtn,
) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
  };
  prevBtn.addEventListener('click', scrollPrev, false);
  nextBtn.addEventListener('click', scrollNext, false);

  const removeTogglePrevNextBtnsActive =
    addTogglePrevNextBtnsActiveRecommendations(emblaApi, prevBtn, nextBtn);

  return () => {
    removeTogglePrevNextBtnsActive();
    prevBtn.removeEventListener('click', scrollPrev, false);
    nextBtn.removeEventListener('click', scrollNext, false);
  };
};

// Flag to prevent multiple initializations
let carouselInitialized = false;

// Function to initialize the embla carousel
function initializeProductRecommendationsCarousel() {
  if (carouselInitialized) {
    return true;
  }

  const emblaNode = document.querySelector('.embla');
  if (!emblaNode) {
    return false;
  }

  const slides = emblaNode.querySelectorAll('.embla__slide');
  if (slides.length === 0) {
    return false;
  }

  const emblaOptions = { loop: true, align: 'start' };

  const viewportNode = emblaNode.querySelector('.embla__viewport');
  const prevBtnNode = emblaNode.querySelector('.embla__button--prev');
  const nextBtnNode = emblaNode.querySelector('.embla__button--next');

  const emblaApi = EmblaCarousel(viewportNode, emblaOptions);

  const removePrevNextBtnsClickHandlers =
    addPrevNextBtnsClickHandlersRecommendations(
      emblaApi,
      prevBtnNode,
      nextBtnNode,
    );

  emblaApi.on('destroy', removePrevNextBtnsClickHandlers);

  // Mark as initialized
  carouselInitialized = true;
  emblaNode.setAttribute('data-embla-initialized', 'true');

  return true;
}

// Function to check if recommendations are loaded
function checkRecommendationsLoaded() {
  if (carouselInitialized) {
    return true;
  }

  const container = document.querySelector('product-recommendations');
  if (!container) {
    return false;
  }

  const slides = container.querySelectorAll('.embla__slide');
  return slides.length > 0;
}

// Main function to wait for and initialize recommendations
function initializeWhenReady() {
  if (carouselInitialized) {
    return;
  }

  // Try immediate initialization
  if (
    checkRecommendationsLoaded() &&
    initializeProductRecommendationsCarousel()
  ) {
    return;
  }

  let attempts = 0;
  const maxAttempts = 50; // 10 seconds at 200ms intervals

  const checkInterval = setInterval(() => {
    if (carouselInitialized) {
      clearInterval(checkInterval);
      return;
    }

    attempts++;

    if (
      checkRecommendationsLoaded() &&
      initializeProductRecommendationsCarousel()
    ) {
      clearInterval(checkInterval);
      return;
    }

    if (attempts >= maxAttempts) {
      console.log('Product recommendations carousel initialization timed out');
      clearInterval(checkInterval);
    }
  }, 200);

  // Use MutationObserver as backup
  const observer = new MutationObserver(() => {
    if (carouselInitialized) {
      observer.disconnect();
      return;
    }

    if (
      checkRecommendationsLoaded() &&
      initializeProductRecommendationsCarousel()
    ) {
      observer.disconnect();
      clearInterval(checkInterval);
    }
  });

  const targetNode =
    document.querySelector('product-recommendations') || document.body;
  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  });

  // Cleanup after 15 seconds
  setTimeout(() => {
    observer.disconnect();
    clearInterval(checkInterval);
  }, 15000);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWhenReady);
} else {
  initializeWhenReady();
}
